/**
 * Searchbar
 * @dependencies gsap 3.x
 */
import { gsap } from 'gsap';

// DOM Elements
const searchModule = document.querySelector('.search-module');
const searchDisplay = document.querySelector('.js-search-module-display');

// Events
let searchOpened = false;
if (searchModule && searchDisplay) {
  const searchToggle = searchModule.querySelectorAll(
    '.js-search-module-open, .js-search-module-close, .js-search-module-backdrop'
  );
  const searchBg = searchModule.querySelector('.js-search-module-bg');
  const searchBackdrop = searchModule.querySelector(
    '.js-search-module-backdrop'
  );
  const searchContent = searchModule.querySelector('.js-search-module-content');
  const searchClose = searchModule.querySelector('.js-search-module-close');
  const searchInput = searchModule.querySelector('input.form-search');

  searchToggle.forEach((el) => {
    el.addEventListener('click', (ev) => {
      ev.preventDefault();

      if (searchOpened) {
        // Blur Search Input on close
        searchInput && searchInput.blur();
        // Closing Animation
        const tl = gsap.timeline();
        tl.to(
          searchBg,
          { scaleY: 0, duration: 0.5, ease: 'power3.out' },
          'start'
        );
        tl.to(
          searchContent,
          { y: -80, autoAlpha: 0, duration: 0.5, ease: 'power3.out' },
          'start+=0'
        );
        tl.to(searchBackdrop, { autoAlpha: 0, duration: 0.5 }, 'start+=0');
        tl.to(searchClose, { autoAlpha: 0, duration: 0.2 }, 'start+=0');
        tl.set(searchDisplay, { autoAlpha: 0 });
        searchOpened = false;
      } else {
        // Focus Search Input on done
        const inputFocus = () => {
          searchInput && searchInput.focus();
        };
        // Opening Animation
        const tl = gsap.timeline({ onComplete: inputFocus });
        tl.set(searchDisplay, { autoAlpha: 1 }, 'start');
        tl.fromTo(
          searchBackdrop,
          { autoAlpha: 0 },
          { autoAlpha: 1, duration: 0.5 },
          'start+=0'
        );
        tl.fromTo(
          searchBg,
          { scaleY: 0 },
          { scaleY: 1, duration: 0.5, ease: 'power3.out' },
          'start+=0'
        );
        tl.fromTo(
          searchClose,
          { y: -80, autoAlpha: 0 },
          { y: 0, autoAlpha: 1, duration: 0.5, ease: 'power3.out' },
          'start+=0.1'
        );
        tl.fromTo(
          searchContent,
          { y: -80, autoAlpha: 0 },
          { y: 0, autoAlpha: 1, duration: 0.5, ease: 'power3.out' },
          'start+=0.15'
        );
        searchOpened = true;
      }
    });
  });
}
